import FormService from '../../services/FormService';

export default {


    data() {

        return {
            seat_class: 'yellow',
            seat_switcher_class: 1,
            selected_seats: [],
            seat_class_update: [],
            bus_floors: [],
            selected_seat: -2,
            changed_place: 1,
            selected_floor: 1,
            x: 0,
            y: 0,
            form: new FormService({
                seats: [],
                floor: 1,
                name: '',
                x_rows_first_floor: 0,
                y_rows_first_floor: 0,
                x_rows_second_floor: 0,
                y_rows_second_floor: 0,
            }),
        }

    },

    methods: {

        selectSeat(x, y, floor) {

            let index = this.findSeat(x, y, floor);

            if (index === -1) {

                if (floor === 2) {
                    this.form.floor = 2;
                }

                this.selected_seats.push({x: x, y: y, color: this.seat_class, floor: floor});
                this.selected_seat = -2;

            } else {
                if (this.selected_seat === index) {
                    this.selected_seats.splice(index, 1);
                    this.selected_seat = -2;
                } else {
                    this.selected_seat = index;
                }
            }

        },

        findSeat(x, y, floor) {
            return this.selected_seats.findIndex((item) => {
                return item.x === x && item.y === y && item.floor === floor;
            });
        },

        getColor(x, y, floor) {
            let col = this.selected_seats.find((item, index) => {
                return item.x === x && item.y === y && item.floor === floor;
            });
            return col !== undefined ? col.color : 'white';
        },

        yellow_button() {
            this.seat_switcher_class = 1;
            this.seat_class = 'yellow';
            this.isSelected('yellow');

        },

        blue_button() {
            this.seat_switcher_class = 2;
            this.seat_class = 'blue';
            this.isSelected('blue');
        },

        green_button() {
            this.seat_switcher_class = 3;
            this.seat_class = 'green';
            this.isSelected('green');
        },

        save() {

            let second_floor = 0;

            this.selected_seats.forEach((item) => {
                if (item.floor === 2) {
                    second_floor += 1;
                }
            });

            if (second_floor <= 0) {
                this.form.floor = 1;
            }

            let x_min_first_floor = Number.MAX_VALUE,
                y_min_first_floor = Number.MAX_VALUE,

                x_max_first_floor = Number.MIN_VALUE,
                y_max_first_floor = Number.MIN_VALUE,

                x_min_second_floor = Number.MAX_VALUE,
                y_min_second_floor = Number.MAX_VALUE,

                x_max_second_floor = Number.MIN_VALUE,
                y_max_second_floor = Number.MIN_VALUE;

            this.selected_seats.forEach(item => {

                if (item.floor === 1) {

                    if (item.x > x_max_first_floor) x_max_first_floor = item.x;
                    if (item.x < x_min_first_floor) x_min_first_floor = item.x;
                    if (item.y > y_max_first_floor) y_max_first_floor = item.y;
                    if (item.y < y_min_first_floor) y_min_first_floor = item.y;
                }

                if (item.floor === 2) {

                    if (item.x > x_max_second_floor) x_max_second_floor = item.x;
                    if (item.x < x_min_second_floor) x_min_second_floor = item.x;
                    if (item.y > y_max_second_floor) y_max_second_floor = item.y;
                    if (item.y < y_min_second_floor) y_min_second_floor = item.y;
                }

            });

            this.form.x_rows_first_floor = (x_max_first_floor - x_min_first_floor + 1);
            this.form.y_rows_first_floor = (y_max_first_floor - y_min_first_floor + 1);

            this.form.x_rows_second_floor = (x_max_second_floor - x_min_second_floor + 1);
            this.form.y_rows_second_floor = (y_max_second_floor - y_min_second_floor + 1);

            this.isSending = true;
            this.form.seats = this.selected_seats;
            this.submitForm(this.$route.params['id']);

        },

        submitForm(id) {

            console.log(id);

            let method = 'post';
            let url = this.route('api.bus-model.store');

            if (id && id.length > 0) {
                url = this.route('api.bus-model.update', {id: id});
            }

            this.form.submit(method, url)
                .then(res => {

                    if (!res.errors) {
                        this.$router.push('/bus-types');
                    } else {
                        console.log(res.errors);
                    }

                })

        },

        changePlace(place) {

            let max_place = this.selected_seats.length;

            if (place <= max_place) {

                let changed_to_x = this.selected_seats[place - 1].x;
                let changed_to_y = this.selected_seats[place - 1].y;

                let selected_place_x = this.selected_seats[this.selected_seat].x;
                let selected_place_y = this.selected_seats[this.selected_seat].y;

                this.selected_seats[this.selected_seat].x = changed_to_x;
                this.selected_seats[this.selected_seat].y = changed_to_y;

                this.selected_seats[place - 1].x = selected_place_x;
                this.selected_seats[place - 1].y = selected_place_y;
            }


        },

        isSelected(color) {

            if (this.selected_seats.length > 0 && this.selected_seat > 0) {
                this.selected_seats[this.selected_seat].color = color;
            }

        },

        firstFloor() {
            this.selected_floor = 1;
        },

        secondFloor() {
            this.selected_floor = 2;
        },


    },

    mounted() {

    },


    created() {

        this.bus_floors[0] = 0;
        this.bus_floors[1] = 1;
        this.bus_floors[2] = 2;

        let id = this.$route.params['id'];
        if (id) {

            this.seat_class_update[1] = 'yellow';
            this.seat_class_update[2] = 'blue';
            this.seat_class_update[3] = 'green';

            this.$api.get('bus-model.edit', id)
                .then(res => {

                    this.form.setData(res.data);
                    let seats = res.data.bus_model_seats;

                    for (let seat in seats) {
                        this.seat_class = this.seat_class_update[seats[seat].type];
                        this.selectSeat(seats[seat].x, seats[seat].y, seats[seat].z);
                    }

                })


        }
    },
}
